import objectUtils from '../utils/object-utils'

export default class ProviderOrderSubmission {
  constructor (options = {}) {
    this.model = 'ProviderOrderSubmission'

    this.id = objectUtils.get(options, 'id', null)
    this.org_id = objectUtils.get(options, 'org_id', null)
    this.order_number = objectUtils.get(options, 'order_number', null)
    this.shipper_id = objectUtils.get(options, 'shipper_id', null)
    this.status = objectUtils.get(options, 'status', null)

    // Third-party references
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)
    this.thirdparty_order_id = objectUtils.get(options, 'thirdparty_order_id', null) // use for provider API calls !!!
    this.thirdparty_order_number = objectUtils.get(options, 'thirdparty_order_number', null)
    this.thirdparty_account_id = objectUtils.get(options, 'thirdparty_account_id', null)
    this.thirdparty_account_name = objectUtils.get(options, 'thirdparty_account_name', null)
    this.thirdparty_brand_id = (options.thirdparty_brand_id && options.thirdparty_brand_id !== 'null') ? options.thirdparty_brand_id : null
    this.thirdparty_brand_name = objectUtils.get(options, 'thirdparty_brand_name', null)

    // Auditing
    this.submitted_by = objectUtils.get(options, 'submitted_by', null)
    this.purchased_by = objectUtils.get(options, 'purchased_by', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.order) this.order = options.order
    if (options.shipper) this.shipper = options.shipper
  }
}
